// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"10":"29e3c96d","76":"f544c7c9","112":"28ed86c7","149":"9508bcdb","188":"a56ec824","309":"eedfd2ba","415":"7d222fb7","551":"84aad9d7","733":"6cd3b2c9"}[chunkId] + ".js";
};